<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="perOptionGarantieDeBonneFin"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Garantie de bonne fin"
                  >
                  </pr-input-radio>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
